module.exports = __webpack_public_path__ + "img/Angiogenesis-BLCA_GSE171351.d7e24199.png";